import { AccountApiUrls, ApiConfig, DeviceApiUrls, EShopApiUrls } from './types';

const prodDiceApiBaseUrl = 'https://warpzone-api.noa.nintendo.com';
const prodNasApiUrl = `${prodDiceApiBaseUrl}/emailornaid`;
const prodDiceMulesoftProxyUrl = `${prodDiceApiBaseUrl}/mulesoft-proxy`;
const prodDiceGameplayProxyUrl = `${prodDiceApiBaseUrl}/gameplay-proxy`;
const prodNcomGraphUrl = 'https://graph.nintendo.com';

const prodAccountApiUrls: AccountApiUrls = {
    accountAndDeviceDetails: (naid: string) => `${prodDiceMulesoftProxyUrl}/account/${naid}`,
    gameRecommendations: (naid: string) => `${prodDiceApiBaseUrl}/account/${naid}/recommendations`,
    gameSummaries: (naid: string) => `${prodDiceGameplayProxyUrl}/${naid}`,
    gameSummaryDetails: (naid: string, applicationId: string) =>
        `${prodDiceGameplayProxyUrl}/${naid}/title/${applicationId}`,
    partOrdersByNaid: (naid: string) =>
        `${prodDiceApiBaseUrl}/partorders?naid=${naid}&sortOrder=desc`,
    partOrdersByEmail: (email: string) =>
        `${prodDiceApiBaseUrl}/partorders?email=${email}&sortOrder=desc`,
    partOrdersByOrderNumber: (orderNumber: string) =>
        `${prodDiceApiBaseUrl}/partorders?orderNumber=${orderNumber}`,
};

const prodDeviceApiUrls: DeviceApiUrls = {
    associatedAccounts: (serialNumber: string) =>
        `${prodDiceMulesoftProxyUrl}/v1_1/device/accounts/${serialNumber}`,
    deviceDetails: (serialNumber: string) =>
        `${prodDiceMulesoftProxyUrl}/v1_1/device/${serialNumber}`,
    deviceRepairs: (serialNumber: string) =>
        `${prodDiceMulesoftProxyUrl}/v1_1/device/repairs?serial_number=${serialNumber}&sort_order=desc&limit=3`,
    deviceRepairsByEmail: (email: string) =>
        `${prodDiceMulesoftProxyUrl}/v1_1/device/repairs?email=${email}&sort_order=desc&limit=3`,
    errorCodes: () => `${prodDiceMulesoftProxyUrl}/v1_1/device/error_codes`,
};

const prodEShopApiUrls: EShopApiUrls = {
    purchaseHistory: (naid: string) => `${prodDiceApiBaseUrl}/account/${naid}/purchase-history`,
};

export const prodApiConfig: ApiConfig = {
    accountApiUrls: prodAccountApiUrls,
    deviceApiUrls: prodDeviceApiUrls,
    eShopApiUrls: prodEShopApiUrls,
    nasUrl: prodNasApiUrl,
    ncomGraphUrl: prodNcomGraphUrl,
};
